export const customStyles = {
  content: {
    top: "56%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: 5,
  },
  overlay: { zIndex: 1000 },
};
